import { RouteComponentProps } from "react-router-dom"
import TaskChat from "../../../tasks/components/TaskChat"

type RouteParams = { taskId: string }

const TaskChatRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  return <TaskChat taskId={match.params.taskId} />
}

export default TaskChatRoute
